module.exports = {
  siteTitle: "Malek's Portfolio", // <title>
  manifestName: 'Prologue',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  // pathPrefix: `/my-portfolio/`, // This path is subpath of your hosting https://domain/portfolio
  authorName: 'Malek Haj-Hussein',
  heading: 'Software Engineer',
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/malekadair',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/MalekAdair',
    },
    {
      icon: 'fa-facebook',
      name: 'Facebook',
      url: 'https://www.facebook.com/MalekHH/',
    },
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      url: 'mailto:malekadair@gmail.com',
    },
  ],
};
